import { render } from "./RecipeUsageReport.vue?vue&type=template&id=55b558da&scoped=true"
import script from "./RecipeUsageReport.vue?vue&type=script&lang=js"
export * from "./RecipeUsageReport.vue?vue&type=script&lang=js"

import "./RecipeUsageReport.vue?vue&type=style&index=0&id=55b558da&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b558da"]])

export default __exports__